import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { CardList, ListCardsQuery } from '@klopotun/contracts';
import { cardQueries } from './card-queries.js';

export const useCardsQuery = (query?: ListCardsQuery): UseQueryResult<CardList> =>
  useQuery(cardQueries.list(query));
